module.exports = __webpack_public_path__ + "media/cases-brand-suning-lazyload-32.6a5de1cb.mp4";